import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      info: null
    };
  }

  componentDidCatch(error, info) {
    const { onError } = this.props;

    if (typeof onError === 'function') {
      try {
        onError.call(this, error, info ? info.componentStack : '');
      } catch (ignoreError) {
        // TODO: send to error log?
      }
    }

    this.setState({ error, info });
  }

  render() {
    const { children, FallbackComponent } = this.props;
    const { error, info } = this.state;

    return error === null ? (
      children
    ) : (
      <FallbackComponent
        componentStack={info ? info.componentStack : ''}
        error={error}
      />
    );
  }
}

ErrorBoundary.defaultProps = {
  onError: null,
  children: null,
  FallbackComponent: <div />
};

ErrorBoundary.propTypes = {
  onError: PropTypes.func,
  children: PropTypes.node,
  FallbackComponent: PropTypes.node
};

export default ErrorBoundary;

export const withErrorBoundary = (
  ChildComponent,
  FallbackComponent,
  onError
) => props => (
  <ErrorBoundary FallbackComponent={FallbackComponent} onError={onError}>
    <ChildComponent {...props} />
  </ErrorBoundary>
);
